'use client';

// Third Party Plugins
import React, { FC } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
// Types
import { SearchFormProps } from './types';
// Styles
import { StyledForm, StyledSearchIcon } from './styles';
import { StyledInput } from '@/components/forms/FormInput/styles';

const SearchForm: FC<SearchFormProps> = ({ searchTerm, setSearchTerm }) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <StyledForm role="search" onSubmit={(e) => e.preventDefault()}>
      <StyledInput
        id="searchInput"
        type="search"
        placeholder="Search by Title"
        value={searchTerm}
        onChange={handleInputChange}
        aria-label="Search By Title"
        style={{ background: 'var(--c-white)' }}
      />
      <StyledSearchIcon icon={faSearch} />
    </StyledForm>
  );
};

export default SearchForm;
